/**
 * core/color.js
 * Các hàm tiện ích thao tác với màu sắc (HEX, RGB, Shading)
 */

/**
 * Làm sáng hoặc làm tối một màu HEX theo tỷ lệ phần trăm
 * @param {string} color - Mã màu HEX (#RRGGBB)
 * @param {number} percent - Phần trăm tăng giảm (-100 đến 100)
 * @returns {string} Mã màu HEX kết quả
 */
export function shadeColor(color, percent) {
  try {
    let num = parseInt(color.replace('#', ''), 16);
    let amt = Math.round(2.55 * percent);
    let R = (num >> 16) + amt;
    let G = ((num >> 8) & 0x00ff) + amt;
    let B = (num & 0x0000ff) + amt;
    return (
      '#' +
      (
        0x1000000 +
        (R < 255 ? (R < 0 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 0 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 0 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    );
  } catch {
    return color;
  }
}

/**
 * Tính độ sáng tương đối (relative luminance) của một màu HEX (0.0 đến 1.0)
 * @param {string} color - Mã màu HEX (#RRGGBB)
 * @returns {number} Độ sáng
 */
export function getColorLuminance(color) {
  try {
    const hex = color.replace('#', '');
    const num = parseInt(hex, 16);
    const r = ((num >> 16) & 255) / 255;
    const g = ((num >> 8) & 255) / 255;
    const b = (num & 255) / 255;
    return 0.299 * r + 0.587 * g + 0.114 * b;
  } catch {
    return 0.5;
  }
}
